<template>
  <v-container fluid grid-list-xl>
    <v-flex xs12 v-if="showError">
      <v-alert
      v-model="showError"
      type="error"
      icon="warning"
      dismissible>
        {{ errorMessage }}
      </v-alert>
    </v-flex>

    <v-btn @click="openInvitationCodeDialog()">Invitation code...</v-btn>

    <v-layout row>

      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-list subheader>
<!--
            <v-subheader v-if="invites.length > 0">My invitations</v-subheader>
            <template v-for="(invite, index) in invites">
              <v-list-tile
              :key="invite.projectId">
  
                <v-list-tile-content
                :key="index">
                  <v-list-tile-title v-html="getTitle(invite)"></v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-btn
                  icon
                  color="primary"
                  :disabled="isAddingUserToProject"
                  @click="openAcceptInviteDialog(invite)">
                    <v-icon>add</v-icon>
                  </v-btn>
                </v-list-tile-action>

              </v-list-tile>
            </template>

            <v-divider></v-divider>
-->
            <v-subheader>My projects</v-subheader>
            <template v-for="(userProject, index) in userProjects">
              <v-list-tile
              :key="userProject.title"
              @click="gotoUserProject(userProject)">
  
                <v-list-tile-content
                :key="index">
                  <v-list-tile-title v-html="userProject.title"></v-list-tile-title>
                  <!-- <v-list-tile-sub-title v-html="userProject.description"></v-list-tile-sub-title> -->
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-btn
                  icon
                  color="primary">
                    <v-icon>arrow_forward</v-icon>
                  </v-btn>
                </v-list-tile-action>

              </v-list-tile>
            </template>

            <!--
            <v-divider></v-divider>

            <v-subheader v-if="filteredUnlockedProjects.length > 0">New projects available</v-subheader>
            <template v-for="(project, index) in filteredUnlockedProjects">
              <v-list-tile :key="project.id">
  
                <v-list-tile-content
                :key="index">
                  <v-list-tile-title v-html="project.title"></v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-btn
                  icon
                  color="primary"
                  :disabled="isAddingUserToProject"
                  @click="openAddProjectDialog(project)">
                    <v-icon>add</v-icon>
                  </v-btn>
                </v-list-tile-action>

              </v-list-tile>
            </template>
            -->
          </v-list>

        </v-card>
      </v-flex>

    </v-layout>

    <!--
    <v-dialog v-model="dialogAddUsetToProject" max-width="500px" v-if="projectToAdd">
      <v-card>
        <v-card-title
        class="headline grey lighten-2"
        primary-title
        >Add project</v-card-title>

        <v-card-text>
          <v-alert
          v-model="showError"
          type="error"
          icon="warning"
          style="margin-bottom:16px;"
          dismissible>
            {{ errorMessage }}
          </v-alert>
      
          <p>Enter the password to join "{{ projectToAdd.title }}".</p>

          <v-text-field
          label="Password"
          v-model="passwordForm"
          :disabled="isAddingUserToProject"
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat
          color="primary"
          :disabled="isAddingUserToProject"
          @click="dialogAddUsetToProject = false"
          >Cancel</v-btn>
          <v-btn flat
          color="primary"
          :disabled="isAddingUserToProject"
          @click="addProject()"
          >Enter</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    -->

    <!--
    <v-dialog v-model="dialogAcceptInvite" max-width="500px" v-if="inviteToAccept">
      <v-card>
        <v-card-title
        class="headline grey lighten-2"
        primary-title
        >Accept invitation</v-card-title>

        <v-card-text>
          <v-alert
          v-model="showError"
          type="error"
          icon="warning"
          style="margin-bottom:16px;"
          dismissible>
            {{ errorMessage }}
          </v-alert>
      
          <p>Click JOIN to accept the invitation to "{{ inviteToAccept.project }}" project</p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat
          color="primary"
          :disabled="isUpdatingInvite"
          @click="dialogAcceptInvite = false"
          >Cancel</v-btn>
          <v-btn flat
          color="primary"
          :disabled="isUpdatingInvite"
          @click="acceptInvite()"
          >Join</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    -->

    <v-dialog v-model="dialogInvitationCode" max-width="500px">
      <v-card>
        <v-card-title
        class="headline grey lighten-2"
        primary-title
        >Insert invitation code to join project</v-card-title>

        <v-card-text>
          <v-alert
          v-model="showErrorDialog"
          type="error"
          icon="warning"
          style="margin-bottom:16px;"
          dismissible>
            {{ errorMessageDialog }}
          </v-alert>

          <v-form @submit.prevent="validateLogin">
            <v-text-field
            label="Invitation code"
            v-model="code"
            :error-messages="codeErrors"
            @input="$v.code.$touch()"
            @blur="$v.code.$touch()"
            required
            ></v-text-field>

          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat
          color="primary"
          :disabled="isUpdatingInvite"
          @click="closeDialogInvitationCode()"
          >Cancel</v-btn>
          <v-btn flat
          color="primary"
          :disabled="isUpdatingInvite || $v.$invalid"
          @click="acceptInvite()"
          >Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// @ is an alias to /src
// import { mapState, mapMutations, mapActions } from 'vuex'
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapMutations, mapActions } = createNamespacedHelpers('usersProjects')
import { mapState as mapStateVuex, mapActions as mapActionsVuex, } from 'vuex';
import { validationMixin } from 'vuelidate';
import {
  required,
  minLength,
  maxLength,
} from 'vuelidate/lib/validators'

export default {
  name: 'Projects',

  components: {
  },

  mixins: [ validationMixin ],

  data: () => ({
    debug: false,

    showError: false,
    errorMessage: '',

    projectToAdd: null,
    dialogAddUsetToProject: false,
    passwordForm: '',
    
    // inviteToAccept: null,
    // dialogAcceptInvite: false,
    code: '',
    showErrorDialog: false,
    errorMessageDialog: '',
    dialogInvitationCode: false,

    // unsubscribeUnlockedProjectsFunctionListner: null
  }),

  props: {
  },

  validations: {
    code: { required, minLength: minLength(20), maxLength: maxLength(20) }
  },

  computed: {
    ...mapState({
      // unlockedProjects: state => state.unlockedProjects, // map `this.unlockedProjects` to `this.$store.state.usersProjects.unlockedProjects`
      userProjects: state => state.userProjects, // map `this.userProjects` to `this.$store.state.usersProjects.userProjects`
      isReadingProjects: state => state.isReadingProjects, // map `this.isReadingProjects` to `this.$store.state.usersProjects.isReadingProjects`
      isAddingUserToProject: state => state.isAddingUserToProject // map `this.isAddingUserToProject` to `this.$store.state.usersProjects.isAddingUserToProject`
    }),

    ...mapStateVuex('invites', {
      // invites: state => state.invites, // map `this.invites` to `this.$store.state.invites.invites`
      isUpdatingInvite: state => state.isUpdatingInvite, // map `this.isUpdatingInvite` to `this.$store.state.invites.isUpdatingInvite`
    }),

    // filteredUnlockedProjects() {
    //   return this.unlockedProjects.filter((item) => {
    //     let found = this.userProjects.find((userProject) => {
    //       return userProject.projectId === item.id
    //     })
    //     return !found
    //   })
    // }

    codeErrors() {
      const errors = [];
      if (this.$v.code.$dirty) {
        !this.$v.code.minLength && errors.push('Must be a valid code');
        !this.$v.code.maxLength && errors.push('Must be a valid code');
        !this.$v.code.required && errors.push('Code is required');
      }
      return errors;
    },
  },

  watch: {
  },

  created () {
    if (this.debug) console.log(this.$options.name+'.created()');
    this.init();
  },

  // mounted() {
  //   if (this.debug) console.log(this.$options.name+'.mounted()');
  //   this.init();
  // },


  // beforeDestroy() {
  //   if (this.debug) console.log(this.$options.name+'.destroyed()');
  //   if (this.unsubscribeUnlockedProjectsFunctionListner) {
  //     this.unsubscribeUnlockedProjectsFunctionListner();
  //   }
  // },

  methods: {
    ...mapMutations([
      'setUserProject' // map `this.setUserProject()` to `this.$store.commit('projects/setUserProject')`
    ]),

    ...mapActions([
      // 'readUnlockedProjects', // map `this.readUnlockedProjects()` to `this.$store.dispatch('usersProjects/readUnlockedProjects')`
      'readMyUserProjects', // map `this.readMyProjects()` to `this.$store.dispatch('usersProjects/readMyUserProjects')`
      'addUserToProject' // map `this.addUserToProject(projectId)` to `this.$store.dispatch('usersProjects/addUserToProject', projectId)`
    ]),

    ...mapActionsVuex('invites', [
      // 'readInvites', // map `this.readInvites()` to `this.$store.dispatch('invites/readInvites')`
      'acceptInviteJoinProject', // map `this.acceptInviteJoinProject()` to `this.$store.dispatch('invites/acceptInviteJoinProject')`
    ]),

    /*
    openAddProjectDialog (project) {
      if (this.debug) console.log(this.$options.name+'.openAddProjectDialog() project:', project);
      this.projectToAdd = project;
      this.dialogAddUsetToProject = true;
    },
    */

    /*
    addProject () {
      if (this.debug) console.log(this.$options.name+'.addProject() this.projectToAdd:', this.projectToAdd)
      // add project to the db and store
      this.addUserToProject({ project: this.projectToAdd, password: this.passwordForm })
      .then(() => {
        this.showError = false
        this.dialogAddUsetToProject = false
        if (this.debug) console.log(this.$options.name+'.addProject() user added to project. Read...');
        this.readMyUserProjects()
        .then(() => {
          // go to userProject after creation
          if (this.debug) console.log(this.$options.name+'.addProject() userProjects:', this.userProjects)
          if (this.debug) console.log(this.$options.name+'.addProject() projectToAdd:', this.projectToAdd)
          let newlyUserProjects = null
          this.userProjects.forEach((userProject) => {
            if (userProject.projectId === this.projectToAdd.id) {
              newlyUserProjects = userProject
            }
          })
          if (this.debug) console.log(this.$options.name+'.addProject() newlyUserProjects:', newlyUserProjects)
          if (newlyUserProjects) {
            this.gotoUserProject(newlyUserProjects)
          }
        })
      })
      .catch((error) => {
        if (this.debug) console.log(this.$options.name+'.addProject() error:',error)
        this.errorMessage = error
        this.showError = true
      })
    },
    */

    init() {
      if (this.debug) console.log(this.$options.name+'.init() readMyUserProjects...');
      this.readMyUserProjects()
      // .then(() => {
      //   if (this.debug) console.log(this.$options.name+'.created() userProjects:', this.userProjects);
      //   return this.readUnlockedProjects()
      //   .then((unsubscribe) => {
      //     this.showError = false
      //     this.unsubscribeUnlockedProjectsFunctionListner = unsubscribe
      //   });
      // })
      .then(() => {
        if (this.$route.query.code) {
          if (this.debug) console.log(this.$options.name+'.created() $route.query:',this.$route.query);
          this.code = this.$route.query.code;
          this.openInvitationCodeDialog();
          this.acceptInvite();
        }
      })
      .catch((error) => {
        if (this.debug) console.log(this.$options.name+'.init() error:', error);
        this.errorMessage = error.message
        this.showError = true;
      });
      // if (this.debug) console.log(this.$options.name+'.init() readInvites...')
      // this.readInvites()
      // .then(() => {
      //   if (this.debug) console.log(this.$options.name+'.init() invites:', this.invites);
      //   this.showError = false;
      //   this.dialogAdd = false;
      // })
      // .catch((error) => {
      //   if (this.debug) console.log(this.$options.name+'.init() error:', error);
      //   this.errorMessage = error;
      //   this.showError = true;
      // });
    },

    openInvitationCodeDialog() {
      if (this.debug) console.log(this.$options.name+'.openInvitationCodeDialog()');
      this.dialogInvitationCode = true;
    },

    closeDialogInvitationCode() {
      this.dialogInvitationCode = false;
      this.code = '';
      this.errorMessageDialog = '';
      this.showErrorDialog = false;
    },

    acceptInvite() {
      if (this.debug) console.log(this.$options.name+'.acceptInvite() code:', this.code);
      // accept invite and add project to the db and store
      this.acceptInviteJoinProject(this.code)
      .then((result) => {
        const joinedProjectId = (result && result.projectId ? result.projectId : null);
        if (this.debug) console.log(this.$options.name+'.acceptInvite() result:', result, 'joinedProjectId:', joinedProjectId);
        if (this.debug) console.log(this.$options.name+'.acceptInvite() user added to project. Read...');
        this.readMyUserProjects()
        .then(() => {
          if (joinedProjectId) {
            // go to userProject after creation
            if (this.debug) console.log(this.$options.name+'.acceptInvite() userProjects:', this.userProjects)
            let newlyUserProjects = null
            this.userProjects.forEach((userProject) => {
              if (userProject.projectId === joinedProjectId) {
                newlyUserProjects = userProject;
              }
            })
            if (this.debug) console.log(this.$options.name+'.acceptInvite() newlyUserProjects:', newlyUserProjects)
            if (newlyUserProjects) {
              this.gotoUserProject(newlyUserProjects);
            }
          }
          this.closeDialogInvitationCode();
        })
      })
      .catch((error) => {
        if (this.debug) console.log(this.$options.name+'.acceptInvite() error:',error)
        this.errorMessageDialog = error;
        this.showErrorDialog = true;
      })
    },

    gotoUserProject(userProject) {
      if (this.debug) console.log(this.$options.name+'.gotoUserProject() userProject:',userProject);
      // set userProject to the store
      this.setUserProject(userProject);
      this.$router.push('/project/'+userProject.projectId);
    },

    getTitle (invite) {
      if (this.debug) console.log(this.$options.name+'.getTitle() invite:', invite);
      return invite.project ? invite.project : invite.projectId;
    }
  }
}
</script>

<style scoped>  /* "scoped" attribute limit the CSS to this component only */
.v-btn.add {
  bottom: 16px;
}
</style>